import type { ArenaConfig } from "../config/gameplay-config";
import {
  resolveSnakeArenaBoundary,
  type ArenaBoundaryContact,
} from "./arena-boundary";
import { turnTowardHeading } from "./player-steering";
import type { Vector2 } from "./player-movement";

export interface SnakeLocomotionState {
  readonly collision: { readonly radius: number };
  readonly directionRadians: number;
  readonly position: Vector2;
  readonly speed: number;
}

export interface SnakeLocomotionResult<TState extends SnakeLocomotionState> {
  readonly contact: ArenaBoundaryContact;
  readonly snake: TState;
}

export const stepSnakeLocomotion = <TState extends SnakeLocomotionState>(
  state: TState,
  desiredHeadingRadians: number,
  turnRateRadiansPerSecond: number,
  stepMilliseconds: number,
  arena: ArenaConfig,
): SnakeLocomotionResult<TState> => {
  const directionRadians = turnTowardHeading(
    state.directionRadians,
    desiredHeadingRadians,
    turnRateRadiansPerSecond,
    stepMilliseconds,
  );
  const distance = state.speed * (stepMilliseconds / 1_000);
  const moved = {
    ...state,
    directionRadians,
    position: {
      x: state.position.x + Math.cos(directionRadians) * distance,
      y: state.position.y + Math.sin(directionRadians) * distance,
    },
  };
  const boundary = resolveSnakeArenaBoundary(moved, arena);
  return {
    contact: boundary.contact,
    snake: boundary.snake,
  };
};
